<template>
  <BasePanelWithHeader headerText="Concerns">
    <template v-slot:content>
      <v-row>
        <v-col class="ml-auto" cols="12" sm="auto">
          <v-text-field
            v-model="searchText"
            prepend-inner-icon="mdi-magnify"
            label="Search"
            clearable
          >
          </v-text-field>
        </v-col>
        <v-col cols="12" sm="auto" class="mt-4 mr-4">
          <BaseTooltipButton
            small
            @click="$refs.luConcernForm.addLuConcern()"
            icon="mdi-plus"
            iconColor="white"
            buttonClass="primary"
            >Add Concern
          </BaseTooltipButton>
        </v-col>
      </v-row>
      <v-data-table
        :headers="filteredHeaders"
        :items="luConcerns"
        :search="searchText"
        class="pt-4"
        :loading="loading"
        dense
      >
        <template v-slot:item.edit="{ item }">
          <BaseTooltipButton
            small
            @click="$refs.luConcernForm.editLuConcern(item)"
            iconColor="primary"
            icon="mdi-pencil"
            >Edit Concern
          </BaseTooltipButton>
        </template>
        <template v-slot:item.delete="{ item }">
          <BaseTooltipButton
            small
            @click="$refs.luConcernDelete.deleteConfirm(item)"
            iconColor="primary"
            icon="mdi-delete"
            >Delete Concern
          </BaseTooltipButton>
        </template>
      </v-data-table>
      <BaseDeleteConfirm
        ref="luConcernDelete"
        :delete="deleteLuConcern"
        @refresh="clearLookupCacheAndReloadLuConcerns"
      >
        Are you sure you want to delete this concern?
      </BaseDeleteConfirm>
      <LuConcernDialogForm
        ref="luConcernForm"
        @refresh="clearLookupCacheAndReloadLuConcerns"
      >
      </LuConcernDialogForm>
    </template>
  </BasePanelWithHeader>
</template>
<script>
import { get, sync, commit, call } from 'vuex-pathify'
import LuConcernDialogForm from '@components/form/add-edit/LuConcernDialog'
export default {
  components: {
    LuConcernDialogForm,
  },
  data: () => ({
    searchText: '',
  }),
  created() {
    this.loadLuConcerns()
  },
  computed: {
    ...get('luConcern', ['luConcerns', 'loading']),
    headers() {
      return [
        {
          text: '',
          align: 'center',
          value: 'edit',
          visible: true,
          sortable: false,
        },
        {
          text: 'ID',
          align: 'center',
          sortable: true,
          value: 'ID',
          visible: false,
        },
        {
          text: 'Description',
          align: 'center',
          sortable: true,
          value: 'Description',
          visible: true,
        },
        {
          text: 'Is Active',
          align: 'center',
          sortable: true,
          value: 'IsActive',
          visible: true,
        },
        {
          text: '',
          align: 'center',
          value: 'delete',
          visible: false,
          sortable: false,
        },
      ]
    },
    filteredHeaders() {
      return this.headers.filter((h) => h.visible)
    },
  },
  methods: {
    ...call('luConcern', [
      'deleteLuConcern',
      'loadLuConcerns',
      'clearLookupCacheAndReloadLuConcerns',
    ]),
  },
}
</script>
<style>
</style>